import React from "react";

const VektorImage = () => {
	return (
		<div className="col-lg-6 d-flex align-items-center d-none d-lg-block">
			<div className="p-3 p-lg-5">
				<img
					src="assets/images/element/signin.svg"
					alt="Register / Masuk LMS M-Knows"
				/>
			</div>
			<div className="vr opacity-1 d-none d-lg-block" />
		</div>
	);
};

export default VektorImage;
